import { Selector } from 'Shared/backend/widgets/Margins';
import { StoreColourPicker } from 'Shared/forms/ColourPicker';
import { LabelOnLeftWrap } from 'Shared/forms/Wrap';

export function Colour()
{
	return (<>
		<Selector/>

		<LabelOnLeftWrap label='Colour' narrow={true}>
			<StoreColourPicker field='colour' />
		</LabelOnLeftWrap>
	</>);
}

